import SuperAdminPage from "./SuperAdminPage";

export const SuperAdminPageConfig = {
  routes: [
    {
      path: "/super",
      exact: true,
      component: SuperAdminPage,
    },
  ],
}; 